import React from "react";
import { Form, Radio, Checkbox, Select, DatePicker, Divider, Input } from "antd";

const { TextArea } = Input;

// Khớp enum Users.role ('user' | 'admin' | 'mod'). CTV chính là role 'mod' —
// từng có ô "CTV" value 'ctv' không tồn tại trong DB nên tick vào ra 0 người.
const ROLE_OPTIONS = [
    { label: "User", value: "user" },
    { label: "CTV (mod)", value: "mod" },
    { label: "Admin", value: "admin" },
];

const PLATFORM_OPTIONS = [
    { value: "ios", label: "iOS" },
    { value: "android", label: "Android" },
    { value: "web", label: "Web" },
];

const ACTIVE_OPTIONS = [
    { value: "true", label: "Đang hoạt động" },
    { value: "false", label: "Bị khoá" },
];

/**
 * Audience selector for push broadcast form.
 * Props:
 *   mode: 'all' | 'roles' | 'ids' | 'criteria'
 *   onModeChange: (mode) => void
 *   selectedRoles: string[]
 *   onRolesChange: (roles) => void
 *   rawIds: string  (comma/newline separated user IDs)
 *   onRawIdsChange: (value) => void
 *   criteria: { platform, active, joinedAfter, joinedBefore }
 *   onCriteriaChange: (key, value) => void
 */
function PushAudienceSelector({ mode, onModeChange, selectedRoles, onRolesChange, rawIds, onRawIdsChange, criteria, onCriteriaChange }) {
    return (
        <div>
            <Form.Item label="Đối tượng nhận">
                <Radio.Group value={mode} onChange={(e) => onModeChange(e.target.value)}>
                    <Radio value="all">Tất cả</Radio>
                    <Radio value="roles">Theo vai trò</Radio>
                    <Radio value="ids">Danh sách User ID</Radio>
                    <Radio value="criteria">Bộ lọc</Radio>
                </Radio.Group>
            </Form.Item>

            {mode === "ids" && (
                <>
                    <Divider orientation="left" plain>Danh sách User ID</Divider>
                    <Form.Item label="User IDs" extra="Nhập mỗi ID trên một dòng hoặc cách nhau bằng dấu phẩy">
                        <TextArea
                            rows={5}
                            placeholder={"123\n456\n789"}
                            value={rawIds}
                            onChange={(e) => onRawIdsChange(e.target.value)}
                        />
                    </Form.Item>
                </>
            )}

            {mode === "roles" && (
                <>
                    <Divider orientation="left" plain>Vai trò</Divider>
                    <Form.Item label="Chọn vai trò">
                        <Checkbox.Group
                            options={ROLE_OPTIONS}
                            value={selectedRoles}
                            onChange={onRolesChange}
                        />
                    </Form.Item>
                </>
            )}

            {mode === "criteria" && (
                <>
                    <Divider orientation="left" plain>Bộ lọc</Divider>
                    <div className="grid grid-cols-2 gap-x-6">
                        <Form.Item label="Nền tảng">
                            <Select
                                allowClear
                                placeholder="Bất kỳ"
                                options={PLATFORM_OPTIONS}
                                value={criteria.platform || undefined}
                                onChange={(v) => onCriteriaChange("platform", v)}
                            />
                        </Form.Item>
                        <Form.Item label="Trạng thái">
                            <Select
                                allowClear
                                placeholder="Bất kỳ"
                                options={ACTIVE_OPTIONS}
                                value={criteria.active !== undefined ? String(criteria.active) : undefined}
                                onChange={(v) => onCriteriaChange("active", v)}
                            />
                        </Form.Item>
                        <Form.Item label="Ngày tham gia (từ - đến)" className="col-span-2">
                            <DatePicker.RangePicker
                                style={{ width: "100%" }}
                                onChange={(dates) => {
                                    onCriteriaChange("joinedAfter", dates?.[0]?.unix() ?? undefined);
                                    onCriteriaChange("joinedBefore", dates?.[1]?.unix() ?? undefined);
                                }}
                            />
                        </Form.Item>
                    </div>
                </>
            )}
        </div>
    );
}

export default PushAudienceSelector;
